/**
 * Standardized input styles for condition/criteria builders
 * These styles ensure consistent width and height across all condition inputs
 * throughout the application (workflows, filters, rules, etc.)
 */

/**
 * Standard input styles for Form.Select, Form.Control, and other input elements
 * Used in condition rows to ensure consistent sizing
 */
export const standardInputStyles = {
  fontSize: '0.95rem',
  padding: '0.5rem 0.75rem',
  minHeight: '40px',
  height: '40px',
  width: '100%',
};

/**
 * Standard label styles for condition input labels
 * Ensures consistent label appearance across all condition builders
 */
export const standardLabelStyles = {
  fontSize: '0.95rem',
  fontWeight: '500',
  marginBottom: '0.5rem',
  lineHeight: '1.2',
};

/**
 * Standard form group margin bottom
 * Provides consistent spacing between form groups
 */
export const standardFormGroupMargin = 'mb-3';

/**
 * Standard container height for custom input components
 * (e.g., FieldSelectorDropdown, LookupLayout, PicklistFieldSelector)
 * Ensures they align with standard inputs
 */
export const standardInputContainerHeight = {
  minHeight: '40px',
};
